
import Vue from 'vue';
import Component from 'vue-class-component';
import {Action, Getter} from 'vuex-class';
import {devreKesiciSifirla} from '@/plugins/uyap-plugin/BaglantiKurtarma';

/**
 * 401 devre kesici açıldığında gösterilir. Görsel dil OturumLimitiDialog ile aynı;
 * ton kritik (kırmızı) çünkü burada işlem kullanıcı müdahalesi olmadan devam etmiyor.
 *
 * Kesici yalnızca buradan sıfırlanır: kullanıcı bilinçli olarak "Yeniden başlat"
 * demeden sayaç temizlenirse aynı istek seli sessizce tekrar başlayabilir.
 */
@Component({})
export default class DevreKesiciDialog extends Vue {
  @Getter devreKesiciUyarisi!: { zaman: number } | null;
  @Action connectToUyap!: (payload?: { force?: boolean }) => Promise<void>;
  @Action devreKesiciUyarisiniKapat!: () => void;

  deneniyor = false;

  get acik(): boolean {
    return this.devreKesiciUyarisi !== null;
  }

  set acik(v: boolean) {
    // persistent dialog; kapatma yalnızca düğmelerden.
    if (!v) this.kapat();
  }

  kapat() {
    this.devreKesiciUyarisiniKapat();
  }

  async yenidenBaslat() {
    this.deneniyor = true;
    try {
      // Sayaç kullanıcının açık talebiyle sıfırlanır; aksi halde ilk 401'de
      // kesici hemen tekrar açılır.
      devreKesiciSifirla();
      await this.connectToUyap({force: true});
    } catch (e) {
      // Hata durum mesajına yazılır; kullanıcı tekrar deneyebilsin diye yutuluyor.
      console.error('Yeniden başlatma denemesi başarısız.', e);
    } finally {
      this.deneniyor = false;
      this.kapat();
    }
  }
}
